import { render, staticRenderFns } from "./goodsMoving.vue?vue&type=template&id=08bb2cd7&"
import script from "./goodsMoving.vue?vue&type=script&lang=js&"
export * from "./goodsMoving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports